import options from './search-box.component';

export default {
    selector: 'dtSearchBox',
    options
};
